/* eslint-disable react/no-danger */
import React from "react";
import { Container } from "react-bootstrap";
import FAQQuestionAnswer from "./FaqQuestionAnswer";
import { isHTML } from "../../utils/commonFunctions";

function FAQSection({ FAQs, title, description = "" }: { FAQs: any[]; title: any; description: any }) {
  return (
    <Container>
      <div className="faqHeading">
        <div aria-hidden className="text-center" dangerouslySetInnerHTML={{ __html: title }} />
        {description && <p className="text-xxl text-center">{description}</p>}
      </div>

      <ul>
        {FAQs.map((FAQ) => {
          const answers = isHTML(FAQ?.Paragraph) ? FAQ?.paragraph : `<p>${FAQ?.paragraph}</p>`;

          return <FAQQuestionAnswer key={FAQ?.title} questions={FAQ?.title} answer={answers} />;
        })}
      </ul>
    </Container>
  );
}

export default FAQSection;
